var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.2 48.78h6.44v2.72h-6.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.17 19.94h2.72v2.72h-2.72z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.15 29.24h.58v3.65h-.58z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m26.83 12.5h9.42v6.44h-9.42z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24.59 35.69h6.71l-6.71-5.84z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17.15 26.45h6.44v1.79h-6.44z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m39.5 26.45h6.44v1.79h-6.44z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m45.36 29.24h.58v3.65h-.58z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m49.46 3.5h-34.92a11 11 0 0 0 -11 11v34.96a11 11 0 0 0 11 11h34.92a11 11 0 0 0 11-11v-34.92a11 11 0 0 0 -11-11.04zm-1.16 33.19a.51.51 0 0 1 -.5-.5 2.29 2.29 0 0 0 -4.58 0 .5.5 0 0 1 -1 0 3.29 3.29 0 0 1 2.14-3.08v-3.87h-4.88v7a.51.51 0 0 1 -.5.5h-.9v11.04h2.29a.5.5 0 0 1 .5.5v3.72a.5.5 0 0 1 -.5.5h-7.44a.5.5 0 0 1 -.5-.5v-15.31h-1.79v15.31a.5.5 0 0 1 -.5.5h-7.44a.5.5 0 0 1 -.5-.5v-3.72a.5.5 0 0 1 .5-.5h2.3v-11.09h-.9a.51.51 0 0 1 -.5-.5v-6.95h-4.87v3.87a3.29 3.29 0 0 1 2.14 3.08.5.5 0 0 1 -.5.5.51.51 0 0 1 -.5-.5 2.29 2.29 0 0 0 -4.58 0 .5.5 0 0 1 -1 0 3.27 3.27 0 0 1 1.86-2.95v-7.24a.51.51 0 0 1 .5-.5h6.94v-2.34a.51.51 0 0 1 .5-.5h5.08v-2.72h-2.84a.5.5 0 0 1 -.5-.5v-3.22h-2.17v1.36a.5.5 0 0 1 -.5.5.5.5 0 0 1 -.5-.5v-3.72a.5.5 0 0 1 .5-.5.5.5 0 0 1 .5.5v1.36h2.17v-3.22a.5.5 0 0 1 .5-.5h10.41a.5.5 0 0 1 .5.5v3.22h2.17v-1.36a.5.5 0 0 1 .5-.5.5.5 0 0 1 .5.5v3.72a.5.5 0 0 1 -.5.5.5.5 0 0 1 -.5-.5v-1.36h-2.17v3.22a.5.5 0 0 1 -.5.5h-2.84v2.72h5.1a.51.51 0 0 1 .5.5v2.29h7a.5.5 0 0 1 .5.5v7.29a3.27 3.27 0 0 1 1.86 2.95.5.5 0 0 1 -.56.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m38.48 35.69v-5.84l-6.71 5.84z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m33.43 48.78h6.44v2.72h-6.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.064dff94b5fe1831bbdf67a0311f4345.svg";
export { ForwardRef as ReactComponent };